export enum LocalRole {
  Admin = "ADMIN",
  Manager = "MANAGER",
  Cashier = "CASHIER",
}
